import React from 'react'
import StyledText from './StyledText'
import styled from 'styled-components';

interface StyledRadio {
    name: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    label: string;
    labelColor?: string;
    radioColor?: string;
    borderWidth?: string;
}

const StyledRadio:React.FC<StyledRadio> = ({ name, checked, onChange, label, labelColor, radioColor = '#000', borderWidth = '1px' }) => {
  return (
    <StyledLabel className="d-flex align-items-center gap-1"
        $radioColor={radioColor}
        $borderWidth={borderWidth}
    >
        <input
            type="radio"
            name={name}
            checked={checked}
            onChange={onChange}
            
        />
        <span className="checkmark"></span>
        <StyledText
        fontSize="14px"
        fontWeight={500}
        textColor={labelColor}
        >
            {label}
        </StyledText>
    </StyledLabel>
  )
}


const StyledLabel = styled.label<{
  $radioColor: string;
  $borderWidth: string;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 12px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 16px;
    height: 16px;
    top: 0;
    left: 0;
    margin: 0;
  }

  .checkmark {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 16px;
    border: ${(props) => props.$borderWidth} solid ${(props) => props.$radioColor}; /* outer ring */
    border-radius: 50%;
    background-color: transparent;
  }

  &:hover .checkmark,
  input:focus-visible + .checkmark {
    border-color: ${(props) => props.$radioColor}; /* subtle hover/focus boost */
  }

  && input:checked ~ .checkmark {
    background-color: transparent;
    border-color: ${(props) => props.$radioColor};
  }

  && .checkmark::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => props.$radioColor};
    display: none; /* hidden by default */
  }

  && input:checked ~ .checkmark::after {
    display: block;
  }
`;

export default StyledRadio